import { render, staticRenderFns } from "./PaymentFailure.vue?vue&type=template&id=4af1043f"
import script from "./PaymentFailure.vue?vue&type=script&lang=js"
export * from "./PaymentFailure.vue?vue&type=script&lang=js"
import style0 from "./PaymentFailure.vue?vue&type=style&index=0&id=4af1043f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports